<div class="mt-3 mb-3 row">
  <div class="arrow-right"></div>

  <div class="col-sm-5">
    <div class="mt-4 ml-3">
      <h2>{{pageTitle}}</h2>
    </div>
    <nav *ngIf="breadcrumbs">
      <ul class="breadcrumb">
        <li *ngFor="let breadcrumb of breadcrumbs;let indexOfElement=index;" class="breadcrumb-item">
          <a *ngIf="indexOfElement + 1 < breadcrumbs.length" href="javascript: void(0);" (click)="navigate(breadcrumb)">{{breadcrumb.label}}</a>
          <span *ngIf="indexOfElement + 1 == breadcrumbs.length">{{breadcrumb.label}}</span>
        </li>
      </ul>
    </nav>
  </div>
  <div class="col-sm-6">
    <div class="w-100 ">
      <img *ngIf="progressBar" class="progress-bar" [src]="progressBar" alt="Progress Bar" />
      <div class="float-right">
        <div>
          <ng-content select="[account]"></ng-content>
          <ng-content select="[button]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="page-separator"></div>
